module.exports = __webpack_public_path__ + "img/squishiland-2.56f40c8c.png";